import {
    Box,
    Button,
    Divider,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Heading,
    HStack,
    Input,
    Text,
    VStack,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { useState } from "react";
import * as Yup from "yup";

// Define validation schema
const profileSchema = Yup.object().shape({
    oldPassword: Yup.string()
        .max(50, "Password must be less than 50 characters")
        .required("Old password is required"),
    newPassword: Yup.string()
        // .min(8, "New password must contain at least 8 characters")
        .max(50, "New password must be less than 50 characters")
        .required("New password is required"),
    newPasswordConfirm: Yup.string()
        // .min(8)
        .max(50, "Confirm new password must be less than 50 characters")
        .required("Confirm new password required")
        .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
});

const ChangePasswordForm = () => {
    return (
        <Formik
            initialValues={{
                oldPassword: "",
                newPassword: "",
                newPasswordConfirm: "",
            }}
            validationSchema={profileSchema}
            onSubmit={(values, actions) => {
                setTimeout(() => {
                    alert(JSON.stringify(values, null, 2));
                    actions.setSubmitting(false);
                }, 1000);
            }}
        >
            {({ isSubmitting }) => (
                <Form>
                    <VStack gap={5} align={"flex-start"} mb={5}>
                        <Field name="oldPassword">
                            {({ field, form }) => (
                                <FormControl
                                    isInvalid={
                                        form.errors.oldPassword &&
                                        form.touched.oldPassword
                                    }
                                >
                                    <FormLabel>Old password</FormLabel>
                                    <Input {...field} type="password" />
                                    <FormErrorMessage>
                                        {form.errors.oldPassword}
                                    </FormErrorMessage>
                                </FormControl>
                            )}
                        </Field>
                        <Field name="newPassword">
                            {({ field, form }) => (
                                <FormControl
                                    isInvalid={
                                        form.errors.newPassword &&
                                        form.touched.newPassword
                                    }
                                >
                                    <FormLabel>New password</FormLabel>
                                    <Input {...field} type="password" />
                                    <FormErrorMessage>
                                        {form.errors.newPassword}
                                    </FormErrorMessage>
                                </FormControl>
                            )}
                        </Field>
                        <Field name="newPasswordConfirm">
                            {({ field, form }) => (
                                <FormControl
                                    isInvalid={
                                        form.errors.newPasswordConfirm &&
                                        form.touched.newPasswordConfirm
                                    }
                                >
                                    <FormLabel>Confirm new password</FormLabel>
                                    <Input {...field} type="password" />
                                    <FormErrorMessage>
                                        {form.errors.newPasswordConfirm}
                                    </FormErrorMessage>
                                </FormControl>
                            )}
                        </Field>
                        <Button
                            type="submit"
                            colorScheme="blue"
                            isLoading={isSubmitting}
                            loadingText="Saving..."
                        >
                            Update password
                        </Button>
                    </VStack>
                </Form>
            )}
        </Formik>
    );
};

const Security = () => {
    const [readyToChangePassword, setReadyToChangePassword] = useState(false);
    return (
        <VStack>
            <Box w={"100%"}>
                <HStack justifyContent={"space-between"}>
                    <Heading size={"md"}>Password</Heading>
                    <Button
                        variant={"outline"}
                        onClick={() =>
                            setReadyToChangePassword(!readyToChangePassword)
                        }
                    >
                        Change password
                    </Button>
                </HStack>
                <Divider borderColor={"gray.300"} />
                {readyToChangePassword ? (
                    <ChangePasswordForm />
                ) : (
                    <Text>
                        Improve your account security with a strong password
                    </Text>
                )}
            </Box>
        </VStack>
    );
};

export default Security;
